import { h, Component } from 'preact'
import PropTypes from 'prop-types'
import { incrementList, nextPage } from '../../stores/SearchFilter'

class ButtonLoadMore extends Component {
  constructor(props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    const { onClick } = this.props

    if (onClick) {
      this.props.onClick()
    }

    nextPage()
    const state = window.store.SearchFilter.getState()
    incrementList({state})
  }

  render() {
    const { loading } = this.props

    let contentButton

    if (loading) {
      contentButton = (
        <div>
          <div className="ml-2 spinner-border" role="status">
            <span className="sr-only">Carregando...</span>
          </div>
          &nbsp; Carregando...
        </div>
      )
    } else {
      contentButton = <span>QUERO VER OUTROS MODELOS <i class="icon icon-arrow-pointing-to-right"></i></span>
    }

    return (
      <div class="container text-center">
        <button className="list-used-models__btn-load-more btn button button--dark button--large button--icon-right button--block d-md-none" onClick={this.handleClick}>
          { contentButton }
        </button>
        <button className="list-used-models__btn-load-more btn button button--large button--primary-line button--icon-right d-none d-md-inline" onClick={this.handleClick}>
          { contentButton }
        </button>
      </div>
    )
  }
}

ButtonLoadMore.defaultProps = {
  loading: false
}

ButtonLoadMore.propTypes = {
  onClick: PropTypes.func,
  loading: PropTypes.boll
}

export default ButtonLoadMore
